// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__A3rrP","colCheckbox":"styles_colCheckbox__2wVKM"};